import {FlowController} from "./flow.controller";
import {LandingController} from "./landing.controller";
import {ChooseMechanismController} from "./choose-mechanism.controller";
import {ErrorController} from "./error.controller";

import * as resolves from "./landing.resolves";
import {NoUserFoundForSamlCredentials} from "./noUserFoundForSamlCredentials";
import {ErrorValidatingSamlMessage} from "./errorValidatingSamlMessage";
import {FmkSignInController} from "./fmkSignInController";
import {InsufficientAssuranceLevel} from "./insufficientAssuranceLevel";

/* @ngInject */
export function landingRoutes($stateProvider) {
    $stateProvider
        .state('landing', {
            url: '/landing?worker&installationUserId&destinationResource&nspIdCardRequired&securityContext',
            controller: LandingController,
            controllerAs: 'vm'
        })
        .state('flow', {
            url: '/flow',
            templateUrl: 'app/landing/flow.html',
            controller: FlowController,
            controllerAs: 'vm'
        })
        .state('chooseMechanism', {
            url: '/chooseMechanism',
            template: '<div ui-view=""></div>',
            resolve: {
                redirect: resolves.chooseMechanismRedirectResolve
            }
        })
        .state('chooseMechanism.list', {
            url: '/list',
            templateUrl: 'app/landing/choose-mechanism.html',
            controller: ChooseMechanismController,
            controllerAs: 'vm',
            resolve: chooseMechanismResolve
        })
        .state('error', {
            url: '/error?errorType&errorMessage&errorParams',
            controller: ErrorController
        })
        .state('noUserFoundForSamlCredentials', {
            url: '/noUserFoundForSamlCredentials?errorMessage&errorParams',
            templateUrl: 'app/landing/noUserFoundForSamlCredentials.html',
            controllerAs: 'vm',
            controller: NoUserFoundForSamlCredentials
        })
        .state('errorValidatingSamlMessage', {
            url: '/errorValidatingSamlMessage?errorMessage',
            templateUrl: 'app/landing/errorValidatingSamlMessage.html',
            controllerAs: 'vm',
            controller: ErrorValidatingSamlMessage
        })
        .state('insufficientAssuranceLevel', {
            url: '/insufficientAssuranceLevel?errorMessage',
            templateUrl: 'app/landing/insufficientAssuranceLevel.html',
            controllerAs: 'vm',
            controller: InsufficientAssuranceLevel
        })
        .state('fmkSignInSuccess', {
            url: '/fmkSignInSuccess',
            templateUrl: 'app/landing/fmk-sign-in-success.html',
            controllerAs: 'vm',
            controller: FmkSignInController
        });
}

let chooseMechanismResolve = {
    destinationInstallation: resolves.destinationInstallation,
    chosenAuthenticationMechanisms: resolves.chosenAuthenticationMechanisms
};
